import React from "react";
import {
  Root,
  PageContent,
  PageHeadingArea,
  PageTitle,
  ResponsiveLayoutWrapper,
  Flex,
} from "@backslashbuild/contractors-ui-library";

import NavBar from "../components/NavBar";
import ContractorTopBar from "../modules/contractors/ContractorTopBar";
import ContractorContactDetailsForm from "../modules/contractors/ContractorContactDetailsForm";
import AcceptContractDialog from "../modules/contractors/AcceptContractDialog";
import PageFooter from "../components/PageFooter";

function EditContactDetails() {
  return (
    <Root>
      <PageContent scrollable>
        <ContractorTopBar />
        <NavBar />
        <PageHeadingArea>
          <PageTitle>Edit contact details</PageTitle>
        </PageHeadingArea>
        <ResponsiveLayoutWrapper>
          <ContractorContactDetailsForm />
        </ResponsiveLayoutWrapper>
        <Flex></Flex>
        <PageFooter />
      </PageContent>
      <AcceptContractDialog />
    </Root>
  );
}

export default EditContactDetails;
